// Agency build stand-in for heycatch.js: same calls, no SDK in the bundle.
// See hpHeycatch in vite.config.js.
const noop = () => {};

export const analytics = {
  init: noop,
  setIdentity: noop,
  resetIdentity: noop,
  setPersonProperties: noop,
  trackEvent: noop,
};
